export default __webpack_public_path__ + "static/media/smart-home-thermostat.1afa3044.svg";